export function tourStyles(isRTL) {
  return {
    options: {
      primaryColor: "var(--purple)",
      textColor: "var(--white)",
      backgroundColor: "#22c55e",
      arrowColor: "#22c55e",
      overlayColor: "var(--bgBlack)",
      zIndex: 99999,
    },
    tooltip: {
      backgroundColor: "#22c55e",
      borderRadius: 12,
      fontFamily: "inherit",
      direction: isRTL ? "rtl" : "ltr",
      textAlign: isRTL ? "right" : "left",
    },
    buttonNext: {
      borderRadius: 8,
      padding: "8px 16px",
      fontSize: 14,
    },
    buttonBack: {
      color: "var(--lessDark)",
      fontSize: 14,
    },
    buttonSkip: {
      color: "var(--lessDark)",
      fontSize: 14,
    },
    buttonClose: {
      color: "var(--lessDark)",
    },
  };
}
